export default {
  service: 'youtube',
  thumbnail: 'https://img.youtube.com/vi/JFm7YDVlqnI/0.jpg',
  id: 'JFm7YDVlqnI',
  url: 'https://www.youtube.com/watch?v=JFm7YDVlqnI'
}